module.exports = __webpack_public_path__ + "img/56.5e6aaf33.jpg";